export default __webpack_public_path__ + "static/layered-waves-haikei-1f4a7444e383e688735fa69a77d398ec.svg";